import { render, staticRenderFns } from "./LoginCompany.vue?vue&type=template&id=2965a15b&scoped=true&"
import script from "./LoginCompany.vue?vue&type=script&lang=js&"
export * from "./LoginCompany.vue?vue&type=script&lang=js&"
import style0 from "./LoginCompany.vue?vue&type=style&index=0&id=2965a15b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965a15b",
  null
  
)

export default component.exports